import { EcsActionType } from "../actions";
export function noticeReducer(state = null, action) {
    var _a;
    switch (action.type) {
        case EcsActionType.SetCfgNotice:
            return (_a = action.payload) !== null && _a !== void 0 ? _a : null;
        case EcsActionType.ResetAll:
            return null;
        default:
            return state;
    }
}
//# sourceMappingURL=noticeReducer.js.map